import { FaCamera } from 'react-icons/fa';
import { CollectionObject } from '../firebase/firebase-user';
import './ImageSlider.css';
import { useEffect, useState, useRef, useMemo } from 'react';
import { getImageUrl } from '../firebase/firebase-verify';
import { createPortal } from 'react-dom';

export function ImageSlider({ shadow, id, type = 'fade', size = "medium", fit = 'cover', data, border, control, auto, captions, load, list, allowFullscreen = false }) {
    const [index, setIndex] = useState(0)
    const [nIndex, setNIndex] = useState([false])
    const [images, setImages] = useState([])
    const [fullscreen, setFullscreen] = useState(null)
    const time = (type === 'fade') ? 3000 : 800;
    const ref = useRef()
    const indexRef = useRef(0)
    const nIndexRef = useRef([false])
    const imagesRef = useRef([])

    useEffect(() => { indexRef.current = index }, [index])
    useEffect(() => { nIndexRef.current = nIndex }, [nIndex])
    useEffect(() => { imagesRef.current = images }, [images])

    useEffect(() => {
        const l = data.length;
        const elements = []
        for (let i = 0; i < l; i++) {
            const img = data[i];
            const caption = (captions) ? img.get('fotograaf') : false
            const src = getImageUrl(img.data.id, size)
            elements.push({ id: img.data.id, caption, src });
        }
        setImages(elements)
        setIndex(0)
        setNIndex([false])
    }, [data])

    // Hold the outgoing image at opacity 1 for two frames, then fade.
    // iOS Safari drops the transition if opacity changes in the insert frame.
    useEffect(() => {
        if (nIndex[0] === false || nIndex[2] !== 'prep') return
        let raf2 = 0
        const raf1 = requestAnimationFrame(() => {
            raf2 = requestAnimationFrame(() => {
                setNIndex((cur) => (cur[0] === false || cur[2] !== 'prep') ? cur : [cur[0], cur[1], 'run'])
            })
        })
        return () => {
            cancelAnimationFrame(raf1)
            cancelAnimationFrame(raf2)
        }
    }, [nIndex])

    useEffect(() => {
        if (nIndex[0] === false || nIndex[2] !== 'run') return
        const k = nIndex[0]
        const id = setTimeout(() => {
            setIndex(k)
            setNIndex([false])
        }, time)
        return () => clearTimeout(id)
    }, [nIndex, time])

    useEffect(() => {
        if (!auto || images.length < 2 || nIndex[0] !== false) return
        const id = setTimeout(next, time * 2)
        return () => clearTimeout(id)
    }, [auto, index, images.length, nIndex, time])

    if (images.length === 0) {
        return (<div></div>)
    }

    function getImages() {
        if (images.length === 0) {
            return
        }

        const el = images[index];
        const elements = [<Image load={load} shadow={shadow} key={el.id} size={fit} src={el.src} caption={el.caption} onOpen={allowFullscreen ? () => setFullscreen(index) : null} />]
        if (nIndex[0] === false) {
            return elements
        }
        const el2 = images[nIndex[0]];
        elements.unshift(<Image shadow={shadow} key={el2.id} size={fit} src={el2.src} caption={el2.caption} onOpen={allowFullscreen ? () => setFullscreen(nIndex[0]) : null} />)

        return elements
    }

    function next() {
        const list = imagesRef.current
        if (list.length > 0 && nIndexRef.current[0] === false) {
            const nI = (indexRef.current + 1) % list.length;
            progress(nI, 'left')
        }
    }
    function previous() {
        const list = imagesRef.current
        if (list.length > 0 && nIndexRef.current[0] === false) {
            const nI = (indexRef.current - 1 < 0) ? list.length - 1 : indexRef.current - 1;
            progress(nI, 'right')
        }
    }
    function setDot(i) {
        if (imagesRef.current.length > 0 && i !== indexRef.current && nIndexRef.current[0] === false) {
            const dir = (i < indexRef.current) ? 'right' : 'left'
            progress(i, dir)
        }
    }
    function progress(nI, dir) {
        if (nIndexRef.current[0] === false) {
            setNIndex([nI, dir, 'prep'])
        }
    }
    return (

        <div className={`image-slider ${type} ${fit} ${(control) ? 'padded' : ''} ${(allowFullscreen) ? 'can-fullscreen' : ''}`}  >
            <div className="content" ref={ref} >
                <div className={(() => {
                    let str = ''
                    if (nIndex[0] !== false) {
                        const s = nIndex[1] || ''
                        const phase = nIndex[2] || ''
                        str = type + ' ' + s + ' ' + phase
                    }
                    return 'images ' + str
                })()
                }>

                    {images && getImages()}

                </div>

            </div>
            {control &&
                <div className="control">
                    <div className='left' onClick={previous} />
                    <div className='right' onClick={next} />
                </div>
            }
            <div className='image-dot'>
                {list && images && images.map((e, i) => {

                    const ti = (nIndex[0] === false) ? index : nIndex[0]
                    return (<div key={'dot' + i} onClick={(e) => { setDot(i, e) }} className={(i === ti) ? 'active' : ''}><div /></div>)
                })}
            </div>
            {allowFullscreen && fullscreen !== null && (
                <FullscreenViewer
                    images={images}
                    startIndex={fullscreen}
                    onClose={() => setFullscreen(null)}
                />
            )}
        </div>
    )
}

function Image({ src, caption, size = 'cover', shadow, load, onOpen }) {

    const [loaded, setLoad] = useState(false)
    const ref = useRef(null);

    function start() {
        setLoad(true)
        if (load) { load(true) }
    }

    useEffect(() => {
        const img = ref.current && ref.current.querySelector('img')
        if (img && img.complete && img.naturalWidth) start()
    }, [src])

    function getClass() {
        const s = (loaded) ? 'loaded' : 'hidden';
        const str = "image " + s
        return str
    }

    function open(e) {
        e.preventDefault()
        e.stopPropagation()
        onOpen()
    }

    return (
        <div className={getClass()} ref={ref} onClick={onOpen ? open : undefined} >

            <div className={`image-case ${size}`}>
                <img
                    src={src}
                    onLoad={start}
                    alt="image"
                    style={shadow ? { boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px' } : undefined}
                />

            </div>
            {caption && caption.length > 0 && (<div className="caption">
                {<FaCamera />}
                {caption}
            </div>)}

        </div>
    )
}

function FullscreenViewer({ images, startIndex, onClose }) {
    const [index, setIndex] = useState(startIndex)
    const [scale, setScale] = useState(1)
    const [pos, setPos] = useState({ x: 0, y: 0 })
    const drag = useRef(null)
    const pointers = useRef(new Map())
    const pinch = useRef(null)
    const stageRef = useRef(null)

    function clamp(n, min, max) {
        return Math.min(max, Math.max(min, n))
    }

    function resetView() {
        setScale(1)
        setPos({ x: 0, y: 0 })
    }

    function zoomBy(amount) {
        setScale(function (s) {
            const next = clamp(Math.round((s + amount) * 100) / 100, 1, 5)
            if (next === 1) setPos({ x: 0, y: 0 })
            return next
        })
    }

    function change(dir) {
        resetView()
        setIndex(function (i) {
            return (i + dir + images.length) % images.length
        })
    }

    function close(e) {
        if (e) e.stopPropagation()
        onClose()
    }

    useEffect(function () {
        function onKey(e) {
            if (e.key === 'Escape') onClose()
            if (e.key === 'ArrowRight') change(1)
            if (e.key === 'ArrowLeft') change(-1)
            if (e.key === '+' || e.key === '=') zoomBy(0.25)
            if (e.key === '-' || e.key === '_') zoomBy(-0.25)
        }
        window.addEventListener('keydown', onKey)
        const prev = document.body.style.overflow
        document.body.style.overflow = 'hidden'
        return function () {
            window.removeEventListener('keydown', onKey)
            document.body.style.overflow = prev
        }
    }, [onClose])

    useEffect(function () {
        const el = stageRef.current
        if (!el) return
        function onWheel(e) {
            e.preventDefault()
            const delta = e.deltaY < 0 ? 0.2 : -0.2
            setScale(function (s) {
                const next = clamp(s + delta, 1, 5)
                if (next === 1) setPos({ x: 0, y: 0 })
                return next
            })
        }
        el.addEventListener('wheel', onWheel, { passive: false })
        return function () { el.removeEventListener('wheel', onWheel) }
    }, [])

    function onPointerDown(e) {
        pointers.current.set(e.pointerId, { x: e.clientX, y: e.clientY })
        e.currentTarget.setPointerCapture(e.pointerId)
        if (pointers.current.size === 2) {
            const pts = Array.from(pointers.current.values())
            pinch.current = {
                dist: Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y),
                scale: scale
            }
            drag.current = null
            return
        }
        if (scale > 1) {
            drag.current = { x: e.clientX - pos.x, y: e.clientY - pos.y }
        }
    }

    function onPointerMove(e) {
        if (!pointers.current.has(e.pointerId)) return
        pointers.current.set(e.pointerId, { x: e.clientX, y: e.clientY })
        if (pointers.current.size === 2 && pinch.current) {
            const pts = Array.from(pointers.current.values())
            const dist = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y)
            const next = clamp(pinch.current.scale * (dist / pinch.current.dist), 1, 5)
            setScale(next)
            if (next === 1) setPos({ x: 0, y: 0 })
            return
        }
        if (!drag.current) return
        setPos({ x: e.clientX - drag.current.x, y: e.clientY - drag.current.y })
    }

    function onPointerUp(e) {
        pointers.current.delete(e.pointerId)
        drag.current = null
        if (pointers.current.size < 2) pinch.current = null
    }

    function onDoubleClick() {
        if (scale > 1) resetView()
        else setScale(2.5)
    }

    const img = images[index]
    if (!img) return null

    return createPortal(
        <div className="image-fs" onClick={close}>
            <button className="image-fs-close" type="button" aria-label="Close" onClick={close}>×</button>
            <div className="image-fs-tools" onClick={function (e) { e.stopPropagation() }}>
                <button type="button" onClick={function () { zoomBy(-0.25) }} aria-label="Zoom out">−</button>
                <button type="button" onClick={resetView} aria-label="Reset zoom">{Math.round(scale * 100)}%</button>
                <button type="button" onClick={function () { zoomBy(0.25) }} aria-label="Zoom in">+</button>
            </div>
            {images.length > 1 && (
                <>
                    <button className="image-fs-nav left" type="button" aria-label="Previous" onClick={function (e) { e.stopPropagation(); change(-1) }} />
                    <button className="image-fs-nav right" type="button" aria-label="Next" onClick={function (e) { e.stopPropagation(); change(1) }} />
                </>
            )}
            <div
                className="image-fs-stage"
                ref={stageRef}
                onClick={function (e) { e.stopPropagation() }}
                onPointerDown={onPointerDown}
                onPointerMove={onPointerMove}
                onPointerUp={onPointerUp}
                onPointerCancel={onPointerUp}
                onDoubleClick={onDoubleClick}
                style={{ cursor: scale > 1 ? 'grab' : 'zoom-in' }}
            >
                <img
                    src={img.src}
                    alt={img.caption || 'image'}
                    draggable={false}
                    style={{ transform: 'translate(' + pos.x + 'px, ' + pos.y + 'px) scale(' + scale + ')' }}
                />
            </div>
            {img.caption && img.caption.length > 0 && (
                <div className="image-fs-caption" onClick={function (e) { e.stopPropagation() }}>
                    <FaCamera />
                    {img.caption}
                </div>
            )}
        </div>,
        document.body
    )
}
